export default "__VITE_ASSET__DsVN7AiM__"